(function () {
  function parseCents(t) { var d = t.replace(/[^\d]/g, ''); return d ? parseInt(d, 10) : 0; }
  function fmt(c) {
    var p = (c / 100).toFixed(2).split('.');
    return 'R$' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1];
  }
  function update(box) {
    var wrap = box.closest('.price');
    var val = wrap && (wrap.querySelector('.price__current .js-value') || wrap.querySelector('.js-value'));
    if (!val) return;
    var cents = parseCents(val.textContent);
    var max = parseInt(box.dataset.maxParcelas, 10) || 10;
    var min = parseInt(box.dataset.minParcela, 10) || 10000;
    var n = 0;
    for (var i = max; i >= 2; i--) { if (Math.floor(cents / i) >= min) { n = i; break; } }
    if (n < 2) { box.hidden = true; return; }
    box.querySelector('.js-ammi-n').textContent = n;
    box.querySelector('.js-ammi-valor').textContent = fmt(Math.ceil(cents / n));
    box.hidden = false;
  }
  function init() {
    document.querySelectorAll('.js-ammi-parcelas').forEach(function (box) {
      if (box.closest('product-block')) return;
      var wrap = box.closest('.price');
      var val = wrap && (wrap.querySelector('.price__current .js-value') || wrap.querySelector('.js-value'));
      if (!val) return;
      update(box);
      new MutationObserver(function () { update(box); })
        .observe(val, { childList: true, characterData: true, subtree: true });
    });
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();